export default __webpack_public_path__ + "static/media/s663-4.79b9f559.png";